var exports = {
  "K": "x127c5a35--fd9183--icon",
};

module.exports = exports;
